import * as React from "react";
import { cn } from "./cn";

export interface PageHeaderProps {
  /** Primary page heading. */
  title: React.ReactNode;
  /** Optional supporting line under the title. */
  description?: React.ReactNode;
  /** Optional right-aligned controls (CTA button, filter, badge…). */
  actions?: React.ReactNode;
  /** Override the wrapper classes (e.g. `hidden md:flex` to hide on mobile). */
  className?: string;
}

/**
 * Standard page header used at the top of top-level routes. Renders the
 * design-system primary heading (`display-lg`) plus an optional description and
 * a right-aligned actions slot. Keeps title/description styling identical
 * across pages so headers never drift.
 */
export function PageHeader({
  title,
  description,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <header
      className={cn(
        "flex flex-wrap items-start justify-between gap-3",
        className,
      )}
    >
      <div className="min-w-0">
        <h1 className="text-display-lg font-extrabold text-ink">{title}</h1>
        {description ? (
          <p className="mt-1 text-sm text-ash">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      ) : null}
    </header>
  );
}
